Alpine.data('downloadableGallery', (randomID, total) => {
	const mobileCount = 3;
	const desktopCount = 7;

	return {
		total,
		showAll: false,
		showOnly: 0,
		currentSlide: null,

		init() {
			this.listenToBrowserResize();
		},
		id(index, suffix = '') {
			return `dg-${randomID}-${index}${suffix}`;
		},
		listenToBrowserResize() {
			// Media query must match the `md` breakpoint in our stylesheets.
			const mql = window.matchMedia('screen and (min-width: 992px)');

			const handleChange = () => {
				this.showOnly = mql.matches ? desktopCount : mobileCount;
			};

			if (typeof mql.addEventListener === 'function') {
				mql.addEventListener('change', () => {
					handleChange();
				});
			} else if (typeof mql.addListener === 'function') {
				mql.addListener(() => {
					handleChange();
				});
			}

			handleChange();
		},
		openModal(currentSlide) {
			this.currentSlide = currentSlide;

			this.$store.aa.modal.open(`modal-downloadable-gallery-${randomID}`);
		},
		next() {
			this.currentSlide = Math.min(this.currentSlide + 1, total - 1);
		},
		prev() {
			this.currentSlide = Math.max(0, this.currentSlide - 1);
		},
	};
});
